module.exports = __webpack_public_path__ + "static/media/Muindejk.102aa357.jpeg";